<template>
    <div>
        <div class="d-sm-block d-mb-block d-lg-none" v-if="isMobile">
            <v-overlay :value="visible" :absolute="false" opacity="1" scroll-strategy="block" class="overlay-mobile">
                <div class="main-container-mobile">
                    <div class="foreground-container-mobile">
                        <div class="first-block-mobile">
                            <div class="lang-switch-wrapper-mobile">
                                <div class="lang-switch-container">
                                    <button 
                                        type="button" 
                                        class="lang-btn" 
                                        :class="{ active: currentLang === 'ru' }" 
                                        @click="setLanguage('ru')"
                                    >
                                        RU
                                    </button>
                                    <span class="lang-divider">|</span>
                                    <button 
                                        type="button" 
                                        class="lang-btn" 
                                        :class="{ active: currentLang === 'kz' }" 
                                        @click="setLanguage('kz')"
                                    >
                                        KZ
                                    </button>
                                </div>
                            </div>
                            <img src="@/assets/img/absolut-age-confirm-logo.svg" alt=""
                                class="jameson-logo-age-confirm-mobile" />
                            <h4 class="title-text-mobile">{{ $t('ageConfirm.title') }}</h4>
                            <div class="date-input-container-mobile">
                                <input type="text" maxlength="2" :placeholder="$t('ageConfirm.placeholderDay')" @input="validateDay" v-model="day"
                                    class="date-input-mobile" />
                                <input type="text" maxlength="2" :placeholder="$t('ageConfirm.placeholderMonth')" @input="validateMonth" v-model="month"
                                    class="date-input-mobile" />
                                <input type="text" maxlength="4" :placeholder="$t('ageConfirm.placeholderYear')" @input="validateYear" v-model="year"
                                    class="date-input-mobile" />
                            </div>
                            <button @click="confirmRegistration"
                                class="btn-confirm-mobile mt-10 mb-10">{{ $t('ageConfirm.confirmBtn') }}</button>
                        </div>
                        <div class="second-block-mobile">
                            <img src="@/assets/img/absolut-age-confirm-mobile-img.png" alt=""
                                class="jameson-age-confirm-mobile" />

                        </div>
                    </div>
                </div>
            </v-overlay>
        </div>
        <div class="d-none d-lg-block d-xl-block d-xxl-block" v-else>
            <v-overlay :value="visible" :absolute="false" opacity="1" scroll-strategy="block">
                <div class="main-container">
                    <div class="lang-switch-wrapper-desktop">
                        <div class="lang-switch-container">
                            <button 
                                type="button" 
                                class="lang-btn" 
                                :class="{ active: currentLang === 'ru' }" 
                                @click="setLanguage('ru')"
                            >
                                RU
                            </button>
                            <span class="lang-divider">|</span>
                            <button 
                                type="button" 
                                class="lang-btn" 
                                :class="{ active: currentLang === 'kz' }" 
                                @click="setLanguage('kz')"
                            >
                                KZ
                            </button>
                        </div>
                    </div>
                    <img src="@/assets/img/age-confirm-bg-1.png" alt="Background" class="background-image" />
                    <div class="foreground-container">
                        <div class="first-block">
                            <img src="@/assets/img/absolut-age-confirm-logo.svg" alt=""
                                class="jameson-logo-age-confirm" />
                            <h4 class="title-text">{{ $t('ageConfirm.title') }}</h4>
                            <div class="date-input-container">
                                <input type="text" maxlength="2" :placeholder="$t('ageConfirm.placeholderDay')" @input="validateDay" v-model="day"
                                    class="date-input" />
                                <input type="text" maxlength="2" :placeholder="$t('ageConfirm.placeholderMonth')" @input="validateMonth" v-model="month"
                                    class="date-input" />
                                <input type="text" maxlength="4" :placeholder="$t('ageConfirm.placeholderYear')" @input="validateYear" v-model="year"
                                    class="date-input" />
                            </div>
                            <button @click="confirmRegistration" class="btn-confirm mt-10 mb-10">{{ $t('ageConfirm.confirmBtn') }}</button>
                        </div>
                        <div class="second-block">
                            <img src="@/assets/img/age-confirm-main-img.png" alt="" class="jameson-age-confirm" />

                        </div>
                    </div>
                </div>
            </v-overlay>
        </div>
        <v-snackbar v-model="snackbar" timeout="3000" class="btn-contaiener">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
                    {{ $t('common.close') }}
                </div>
            </template>
        </v-snackbar>
    </div>
</template>

<style scoped>
/* ----------------------------------------Desktop main styles */
::v-deep .v-overlay__scrim {
    opacity: 1;
    /* background-color: #007749 !important;
    border-color: #007749 !important; */
    background-image: url('../assets/img/absolut-age-confirm-bg-mobile.png');
    background-size: cover;
    background-position: center;
}

/* .overlay-mobile ::v-deep .v-overlay__scrim {
    background-image: url('../assets/img/absolut-age-confirm-bg-mobile.png') !important;
    background-size: cover !important;
    background-position: center !important;
    opacity: 1 !important;
} */

/* @media (max-width: 1263px) {
    ::v-deep .v-overlay__scrim {
        background-image: url('../assets/img/absolut-age-confirm-bg-mobile.png') !important;
        background-size: cover !important;
        background-position: center !important;
        opacity: 1 !important;
    }
} */

.main-container {
    position: relative;
    /* Родительский контейнер для абсолютного позиционирования */
    height: 100vh;
    /* Высота на весь экран */
    width: 100vw;
    /* Ширина на весь экран */
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    /* Убираем прокрутку */
}
.background-image {
    position: absolute;
    /* Абсолютное позиционирование */
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
    /* Пропорциональное сжатие */
    z-index: 1;
    /* Отправляем изображение на задний план */
}
.foreground-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1000;
    color: #000;
    font-size: 24px;
    gap: 110px;
    width: 100%;
    max-width: 1300px;
    padding: 0 40px;
    box-sizing: border-box;
}
.first-block {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    margin-left: 20px;
}
.jameson-logo-age-confirm {
    max-width: 320px;
    width: 100%;
    height: auto;
}
.second-block {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 550px;
    max-height: 80vh;
}
.jameson-age-confirm {
    max-width: 100%;
    max-height: 75vh;
    width: auto;
    height: auto;
    object-fit: contain;
}
.title-text {
    margin-bottom: 0px;
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 30px;
    color: var(--color-white);
    margin-top: 35px;
}
.date-input-container {
    display: flex;
    gap: 14px;
    margin-bottom: 25px;
    justify-content: center;
    margin-top: 35px;
}
.date-input {
    width: 115px;
    height: 55px;
    border: 2px solid var(--color-white);
    border-radius: 10px;
    background-color: transparent;
    text-align: center;
    font-family: var(--font-family);
    font-weight: 400;
    font-size: var(--font-size-md);
    color: var(--color-white);
    outline: none;
}

.date-input::placeholder {
    color: var(--color-white);
    font-family: var(--font-family);
    font-weight: 400;
    font-size: var(--font-size-md);
    opacity: 1;
}

.date-input:focus {
    border-color: red;
}

/* Убираем стрелочки */
.date-input::-webkit-inner-spin-button,
.date-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.date-input {
    -moz-appearance: textfield;
    /* Для Firefox */
}
.btn-confirm,
.btn-confirm-mobile {
    border-radius: 10px;
    padding: 11px 42px;
    height: 59px;
    color: var(--color-primary);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-md);
    background: var(--color-white);
    cursor: pointer;
    /* box-shadow: 0 4px 0 #04581d; */
    /* легкая тень для объёма */

    /* медленный возврат */
    transition: all 0.4s ease;
}

/* При наведении */
.btn-confirm:hover,
.btn-confirm-mobile:hover {
    background: #f5f5f5;
    /* лёгкое затемнение белого */
    transform: translateY(-2px);
    box-shadow: 0 6px 0 #bcbcbc;

    /* ускоренный вход */
    transition: all 0.15s ease-out;
}

/* При нажатии */
.btn-confirm:active,
.btn-confirm-mobile:active {
    background: #e6e6e6;
    /* чуть темнее для нажатия */
    transform: translateY(2px);
    box-shadow: 0 2px 0 #9e9e9e;
    transition: all 0.1s ease-in;
}


/* ------------------------------------------------Mobile styles */

.overlay-mobile {
    z-index: 99999 !important;
    align-items: flex-start !important;
    justify-content: flex-start !important;
}

.overlay-mobile ::v-deep .v-overlay__content {
  position: relative;
  width: 100vw;
  height: 100%;
  height: 100vh;
  height: 100dvh;
  max-height: 100%;
  max-height: 100vh;
  max-height: 100dvh;
  overflow-y: auto;  /* включаем скролл внутри */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.main-container-mobile {
    /* background-image: url('../assets/img/absolut-age-confirm-bg-mobile.png'); */
    background-size: cover;
    background-position: center;
    position: relative;
    /* min-height: 100vh; */
    width: 100vw;
    min-height: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
}

.foreground-container-mobile {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 1000;
    color: #000;
    font-size: 24px;
    min-height: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    width: 100%;
    box-sizing: border-box;
}

.first-block-mobile {
    padding-top: max(40px, env(safe-area-inset-top, 40px));
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.second-block-mobile {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin-top: auto;
}

.jameson-age-confirm-mobile {
    max-width: 100%;
    /* width: 100%; */
    height: auto;
    display: block;
    object-fit: contain;
}

.jameson-logo-age-confirm-mobile {
    width: 285.48px;
    max-width: 85vw;
    height: auto;
}

.title-text-mobile {
    margin-bottom: 0px;
    font-family: var(--font-family);
    color: var(--color-white);
    font-size: var(--font-size-md);
    line-height: 117%;
    letter-spacing: 0.04em;
    text-align: center;
    font-weight: 400;
    margin-top: 33px;
}

.title-text-mobile pre {
    margin-bottom: 0px;
    font-family: var(--font-family);
    color: var(--color-white);
    font-size: var(--font-size-md);
    line-height: 117%;
    letter-spacing: 0.04em;
    text-align: center;
    font-weight: 400;
}

.date-input-container-mobile {
    display: flex;
    flex-direction: column;
    gap: 25px;
    margin-bottom: 20px;
    justify-content: center;
    margin-top: 33px;
    text-align: center;
    align-items: center;
}

.date-input-mobile {
    width: 295px;
    height: 55px;
    border: 2px solid var(--color-white);
    border-radius: 10px;
    background-color: transparent;
    text-align: center;
    font-family: var(--font-family);
    font-weight: 400;
    font-size: var(--font-size-xs);
    color: var(--color-white);
    outline: none;
}

.date-input-mobile::placeholder {
    color: var(--color-white);
    font-family: var(--font-family);
    font-weight: 400;
    font-size: var(--font-size-xs);
    opacity: 1;
}

.date-input-mobile:focus {
    border-color: red;
}

/* ------------------------------Styles для распихивание элементов по 4 углам */

.background-image-mobile-botright {
    position: absolute;
    bottom: -1px;
    right: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;
}

.background-image-mobile-botleft {
    position: absolute;
    bottom: -1px;
    left: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;

}

.background-image-mobile-topright {
    position: absolute;
    top: -1px;
    right: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;
}

.background-image-mobile-topleft {
    position: absolute;
    top: -1px;
    left: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;
}

/* .background-image-mobile {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    z-index: 1;
} */

/* ---------------------------------------- Language Switcher */
.lang-switch-wrapper-desktop {
    position: absolute;
    top: 24px;
    right: 32px;
    z-index: 1001;
    display: flex;
    justify-content: flex-end;
}

.lang-switch-wrapper-mobile {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 0 20px 12px 20px;
    box-sizing: border-box;
}

.lang-switch-container {
    display: inline-flex;
    align-items: center;
    background: rgba(0, 0, 0, 0.28);
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-radius: 18px;
    padding: 2px 4px;
    gap: 2px;
    backdrop-filter: blur(4px);
}

.lang-btn {
    background: transparent;
    border: none;
    outline: none;
    font-family: var(--font-family-bold, "MontserratBold", sans-serif);
    font-size: 11px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.85);
    padding: 3px 8px;
    border-radius: 14px;
    cursor: pointer;
    line-height: 1.1;
    letter-spacing: 0.5px;
    transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.lang-btn:hover {
    color: #FFFFFF;
}

.lang-btn.active {
    background: #FFFFFF;
    color: var(--color-primary, #DD1814);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.lang-divider {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.4);
    user-select: none;
}

/*----------------------------------- Snackbar styles */
.snackbar-btn {
    color: var(--Red, #eb5757);
     font-family: var(--font-family);
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    line-height: 1.25rem;
    margin-right: auto;
    padding: 14px 16px;
    text-align: initial;
    cursor: pointer;
}

/* @media (orientation: landscape) {
    .foreground-container-mobile {
        height: auto;
    }
} */
</style>

<script>
import { mapActions } from "vuex";

export default {
    name: "ConfirmAge1",
    data() {
        return {
            isMobile: window.innerWidth < 1264,
            day: "",
            month: "",
            year: "",
            snackbar: false,
            message: "",
            visible: true,
        };
    },
    computed: {
        currentLang() {
            return this.$i18n.locale;
        }
    },
    methods: {
        ...mapActions(['saveUserAge']),

        setLanguage(lang) {
            this.$i18n.locale = lang;
            localStorage.setItem("userLang", lang);
        },

        handleResize() {
            this.isMobile = window.innerWidth < 1264;
        },
        validateDay() {
            // Убираем все символы, кроме цифр, и ограничиваем длину до 2 символов
            this.day = this.day.replace(/\D/g, "").slice(0, 2);

            // Проверяем, что значение не превышает 31
            if (this.day > 31) {
                this.day = ""; // Очищаем поле, если значение некорректно
                this.snackbar = true;
                this.message = this.$t('ageConfirm.errors.invalidDay');
            }
        },
        validateMonth() {
            // Убираем все символы, кроме цифр, и ограничиваем длину до 2 символов
            this.month = this.month.replace(/\D/g, "").slice(0, 2);

            // Проверяем, что значение не превышает 12
            if (this.month > 12) {
                this.month = ""; // Очищаем поле, если значение некорректно
                this.snackbar = true;
                this.message = this.$t('ageConfirm.errors.invalidMonth');
            }
        },
        validateYear() {
            // Убираем все символы, кроме цифр, и ограничиваем длину до 4 символов
            this.year = this.year.replace(/\D/g, "").slice(0, 4);
        },
        confirmRegistration() {
            let isValid = true;

            // Проверяем корректность дня
            if (this.day.length !== 2 || this.day > 31 || this.day < 1) {
                this.day = ""; // Очищаем поле
                this.snackbar = true;
                this.message = this.$t('ageConfirm.errors.invalidDay');
                isValid = false;
            }

            // Проверяем корректность месяца
            if (this.month.length !== 2 || this.month > 12 || this.month < 1) {
                this.month = ""; // Очищаем поле
                this.snackbar = true;
                this.message = this.$t('ageConfirm.errors.invalidMonth');
                isValid = false;
            }

            // Проверяем корректность года
            if (this.year.length !== 4 || this.year < 1900 || this.year > new Date().getFullYear()) {
                this.year = ""; // Очищаем поле
                this.snackbar = true;
                this.message = this.$t('ageConfirm.errors.invalidYear');
                isValid = false;
            }

            // Если есть некорректные поля, прекращаем выполнение
            if (!isValid) {
                return;
            }

            // Проверяем, что дата корректна
            const today = new Date();
            const birthDate = new Date(this.year, this.month - 1, this.day);

            if (
                birthDate.getDate() != this.day ||
                birthDate.getMonth() + 1 != this.month ||
                birthDate.getFullYear() != this.year
            ) {
                this.snackbar = true;
                this.message = this.$t('ageConfirm.errors.invalidDate');
                return;
            }

            // Проверяем возраст
            const age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            const dayDiff = today.getDate() - birthDate.getDate();

            if (age > 21 || (age === 21 && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0)))) {
                console.log(`Дата рождения: ${this.day}.${this.month}.${this.year}`);
                const userAge = `${this.year}-${this.month}-${this.day}`; // строка вида "дд.мм.гггг"

                this.saveUserAge(userAge);
                this.$emit('confirmed');
                this.visible = false;
                document.body.style.overflow = "";
                document.body.style.height = ""; // Сохраняем в Vuex
            } else {
                this.snackbar = true;
                this.message = this.$t('ageConfirm.errors.underage');
                return;
            }
        },
    },
    beforeDestroy() {
        document.body.style.overflow = "";
        document.body.style.height = "";
        window.removeEventListener('resize', this.handleResize);
    },
    mounted() {
        document.body.style.overflow = "hidden";
        document.body.style.height = "100%";
        window.addEventListener('resize', this.handleResize);
    }
}
</script>